import { Injectable, Inject } from '@angular/core';
import { map, first } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// import { Http, Headers, RequestOptions } from '@angular/http';
import { GatewayApi } from '../app.globalVriables';
import { environment } from '../../../environments/environment';
import { CommonService } from '@services/app.common.service';
import { JwtService } from './jwt.service';
import { StatusCode } from '../_enums/Common';
import { IdServer } from '../_enums/idServer';
import { RoleAccessService } from './role.access.service';
import { Router } from '@angular/router';
import { AccessCode, VerifyEmailCode } from '../../login/two-factor-authentication/interface/two-factor-authentication.interface';
import { TwoFactorAuthenticationService } from './two-factor-authentication.service';
import { JTUserIdleService } from '@shared/userIdle/user-idle.service';
import { PwnedPasswordService } from './pwned-password.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  public _baseUrl;
  private redirectUrl = 'Home';
  private isloggedIn = false;
  private loginUrl = '/Login';
  public error = '';
  private appUrl: string;
  isPasswordBreached: boolean = false;
  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string, private common: CommonService,
    public roleService: RoleAccessService, private router: Router,
    private userIdle: JTUserIdleService, private jwtService: JwtService, public pwnedPasswordService: PwnedPasswordService) {
    this._baseUrl = baseUrl + "api/";

    if (environment.production) {
      this.appUrl = this._baseUrl;
    } else {
      this.appUrl = this.serviceUrl;
    }

  }
  private serviceUrl = environment.LoginUrl;
  public antiForgerytoken = '';
  private headers = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Origin': '*', 'Access-Control-Expose-Headers': '*', 'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS', 'Access-Control-Allow-Headers': '*' });
  private options = { headers: this.headers };
  async login(username: string, password: string, callback?: any, shouldCheckBreachedPassword: boolean = false) {
    var $this = this;
    this.antiForgerytoken = this.common.GetFromLocalStorage("forgeryToken");
    this.isPasswordBreached = await this.pwnedPasswordService.isPasswordBreached(password, shouldCheckBreachedPassword);
    
    this.http.post(this.appUrl + this.common.ApiUrls.Login.Login, { UserName: username, Password: password, AFT: this.antiForgerytoken }).pipe(first()).subscribe(data => {
        var res: any;
        res = data;
      if (res.status == StatusCode.OK) {
        if (this.isPasswordBreached) {
          this.common.SetLocalStorage('jt_password_compromised', 'Yes');
        } else {
          this.common.RemoveLocalStorage('jt_password_compromised');
        }
          let loginConfig = this.common.JsonParseData(res.resultData.loginConfiguration)
          if (loginConfig.FeatureTwoFa) {
            if (loginConfig.ForceTwoFactorAuthentication) {
              this.navigate(loginConfig.IsTwoFactorEnabled ? "/2Fa/VerifyCode" : "/2Fa/TwoFactorAuthentication", loginConfig);
            }
            else {
              if (loginConfig.IsTwoFactorEnabled && !loginConfig.IsTwoFactorDisabledByUser) {
                this.navigate("/2Fa/VerifyCode", loginConfig);
              }
              else 
                this.doLogin(callback, loginConfig, res.resultData.access_token);
            }
          }
          else
            this.doLogin(callback, loginConfig, res.resultData.access_token);
        }
        else {
          $this.common.Loader.hide();
          $this.error = 'Login.InvalidCredential';
        }
      });
  }
  getAntiForgeryToken() {
    const $this = this;

    return this.http.post(this.appUrl + this.common.ApiUrls.Login.getAntiForgeryToken, {}).pipe(first());

    // return this.http
    //   .post(this.appUrl + this.common.ApiUrls.Login.getAntiForgeryToken, { }).pipe(first()).subscribe(data => {
    //     var res: any;
    //     res = data;
    //     if (res.status == StatusCode.OK) {

    //     } else {

    //     }
    //   });
  }
  GetOwnSecurityRole(callback?: any, isNavigate = true) {
    const $this = this;
    this.common.GetData(this.common.ApiUrls.Login.GetOwnSecurityRoleDetail, true).then(function (data) {
      if (data.status == StatusCode.OK) {
        $this.common.SetLocalStorage('active_menu_index', '1');
        let url = $this.getRedirectUrl();
        console.log(url);
        $this.common.SetLocalStorage('jt_permissions', JSON.stringify(data.resultData.securityRoleDetail));
        $this.common.SetLocalStorage('jt_user_info', JSON.stringify(data.resultData.user));
        $this.common.SetLocalStorage('jt_date_format', data.resultData.dateFormat);
        $this.common.SetLocalStorage('jt_security_role', JSON.stringify(data.resultData.securityRole));
        $this.common.SetLocalStorage('whiteLabel_permissions', JSON.stringify(data.resultData.whitelabelsecuritysettings));
        $this.common.SetLocalStorage('clientConfigurations', JSON.stringify(data.resultData.clientConfigurations));
        $this.common.SetLocalStorage('lastTokenRefreshtime', new Date());
        $this.common.RemoveLocalStorage('refreshTokenInProgress');
        if (!$this.common.isNullOrWhiteSpace(data.resultData?.landingPageUrl)) {
          $this.common.SetLocalStorage('landingPageUrl', data.resultData?.landingPageUrl);
          $this.setRedirectUrl(data.resultData?.landingPageUrl)
          url = $this.getRedirectUrl();
        }
        else {
          $this.common.RemoveLocalStorage('landingPageUrl');
        }

        const accessType = 'Access';
        if ($this.isPasswordBreached) {
          url = 'changeCompromisedPassword';
        }
        else if (url.toLowerCase().toString() == 'home' && !$this.roleService.HasAccess('Dashboard', accessType)) {
          url = 'JobsAndTalents/Jobs/List';
        }

        $this.common.loadTheme("");

        $this.common.Loader.hide();
        // alert('done');

        if (isNavigate) {
          $this.router.navigateByUrl(url);
        }


        if (callback) {
          callback();
        }
      } else {
        $this.error = 'Login.InvalidCredential';
        $this.common.Loader.hide();
      }
    });
  }

  refreshToken() { 
    return this.http
      .post(this.appUrl + this.common.ApiUrls.Login.RefreshToken, {});


  }

  keepAlive() {

    return this.http
      .post(this.appUrl + this.common.ApiUrls.System.KeepAlive, {});


  }


  public GetTokenByType(type: number) {

    let url = '';
    if (type == IdServer.TokenType.Anonymous) {
      url = this.common.ApiUrls.Login.AnonymousToken;
    } else if (type == IdServer.TokenType.Sso) {
      url = this.common.ApiUrls.Login.SSOToken;
 } else if (type == IdServer.TokenType.SSOLogin) {
      url = this.common.ApiUrls.Login.SSOLogin;
 } else if (type == IdServer.TokenType.ATSLogin) {
      url = this.common.ApiUrls.Login.ATSToken;
 }
    url = this.appUrl + url;
    return this.http
      .post(url, {}).pipe(map((data: any) => {
        const result = data;
        if (result.status == StatusCode.OK) {
          return result;
        } else {
          return null;
        }
      }));


  }




  isUserLoggedIn(): boolean {

    const token = this.common.GetAccessToken();
    // const decodedToken = this.jwtService.decodeToken(token);
    // const expirationDate = this.jwtService.getTokenExpirationDate(token);
    // if (token == null || token == '') {
    //  return false;
    // }
    // else {
    //  return true;
    // }
    const date = this.jwtService.getTokenExpirationDate(token);
    return !this.jwtService.isTokenExpired(token);
  }
  GetTokenExpirationDate(): Date {
    const token = this.common.GetAccessToken();
    return this.jwtService.getTokenExpirationDate(token) ?? new Date();
  }
  isUserPasswordChange(): boolean {
    let response = false;
    const userInfo = this.common.JsonParseData(this.common.GetFromLocalStorage('jt_user_info'));
    if (!this.common.isNullOrWhiteSpace(userInfo) && userInfo.forcePasswordChange == 'Yes') {
      response = true;
    }
    return response;
  }
  isPasswordCompromised(): boolean {
    return this.common.GetFromLocalStorage('jt_password_compromised') == 'Yes';
  }
  getRedirectUrl(): string {
    return this.redirectUrl;
  }
  setRedirectUrl(url: string): void {

    // try {
    //  url = url.substr(1);
    // } catch (e) {

    // }
    this.redirectUrl = url;
  }
  getLoginUrl(): string {
    // if (this.common.ssoConfig != undefined) {
    //  if (this.common.ssoConfig.SingleSignOn == "Yes" && this.common.ssoConfig.SingleSignOn_Type == "Microsoft" && this.common.ssoConfig.ForceSingleSignIn_Microsoft == "Y") {
    //    this.loginUrl = 'Login1';
    //  }
    // }
    return this.loginUrl;
  }

  logout() {
    // remove user from local storage to log user out
    this.common.RemoveLocalStorage('token');
    this.common.RemoveLocalStorage('jt_password_compromised');
  }



  navigate(route: string, loginConfig: any): void {
    this.common.Loader.hide();
    this.common.SetLocalStorage('2FAConfiguration', JSON.stringify(loginConfig));
    this.common.NavigateToRoute(route);
  }

  doLogin(callback: any, loginConfig: any, accessToken: string): void {
    this.common.SetAccessToken(accessToken);
    this.common.RemoveLocalStorage("QuickLinks");
    this.common.SetLocalStorage('2FAConfiguration', JSON.stringify(loginConfig));
    this.userIdle.startWatching();
    this.userIdle.resetTimer();
    this.GetOwnSecurityRole(callback);
  }
}
